'use client';

import { RotateCcw, Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';

import { COPY } from '@/shared/constants/copies';

import { useVideoRecording } from '../video-recording-provider';

export function ConfirmationDialog() {
	const { modalState, handleConfirm, handleCancel } = useVideoRecording();

	return (
		<Dialog
			open={modalState.showConfirmModal}
			onOpenChange={(open) => !open && handleCancel()}
		>
			<DialogContent className="max-w-md">
				<div className="text-center">
					<div className="mb-4 flex justify-center">
						{modalState.confirmAction === 'delete' ? (
							<div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
								<Trash2 className="h-6 w-6 text-red-600" />
							</div>
						) : (
							<div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
								<RotateCcw className="h-6 w-6 text-blue-600" />
							</div>
						)}
					</div>
					<DialogTitle className="mb-2 text-lg font-semibold text-gray-900">
						{COPY.confirms.areYouSure}
					</DialogTitle>
					<DialogDescription className="mb-6 text-sm text-gray-600">
						{modalState.confirmAction === 'delete'
							? COPY.fields.videoDeleteConfirm
							: COPY.fields.videoRetakeConfirm}
					</DialogDescription>
					<div className="flex gap-3">
						<Button
							type="button"
							variant="outline"
							className="flex-1"
							onClick={handleCancel}
						>
							Cancel
						</Button>
						<Button
							type="button"
							variant={modalState.confirmAction === 'delete' ? 'destructive' : 'default'}
							className="flex-1"
							onClick={handleConfirm}
						>
							{modalState.confirmAction === 'delete' ? 'Yes, delete' : 'Yes, retake'}
						</Button>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
}
